@let user = LocalStorage.user;
@let totals = viewedTotals();
<app-page>
    <app-page-header [title]="viewedName() ?? ''">
        <app-avatar [name]="viewedName() ?? ''" [seed]="viewedUserId() ?? null" leading size="lg"></app-avatar>
        @if (isOwn()) {
            <span class="ui-muted">{{ user?.email }}</span>
        } @else {
            <button (click)="selectUser(ownUserId)" actions mat-stroked-button type="button">
                <i class="fa-regular fa-arrow-left"></i> Terug naar mijn profiel
            </button>
        }
    </app-page-header>

    <div class="columns">
        <div class="column">
            <app-section [flush]="true"
                         [subtitle]="totals ? (totals.employment_start ? 'Sinds ' + (totals.employment_start | date:'d MMMM yyyy') + ' tot en met vandaag' : 'Geen datum in dienst ingesteld') : ''"
                         icon="chart-simple"
                         layout="stacked"
                         title="Totalen">
                <div class="stats">
                    <div class="stat">
                        <span class="stat-label">Vakantiebalans</span>
                        <span [class.ui-error]="totals?.vacation_balance_minutes < 0" class="stat-value">{{ totals ? (totals.vacation_balance_minutes | minutes:false) : '…' }}<span class="stat-unit">uur</span></span>
                        @if (totals?.vacation_balance_minutes) {
                            <span class="stat-hint">≈ {{ totals.vacation_balance_minutes / 60 / 8 | number:'1.0-1' }} dagen van 8 uur</span>
                        }
                    </div>
                    <div class="stat">
                        <span class="stat-label">Totaalbalans</span>
                        <span [class.ui-error]="totals?.balance_minutes < 0" class="stat-value">{{ totals ? (totals.balance_minutes | minutes:false) : '…' }}<span class="stat-unit">uur</span></span>
                        @if (totals) {
                            <span class="stat-hint">{{ totals.balance_minutes < 0 ? 'Minder geregistreerd dan contract' : 'Geregistreerd min contracturen' }}</span>
                        }
                    </div>
                </div>
                @if (totals?.per_year.length) {
                    <app-data-list class="years" columns="44px repeat(7,minmax(58px,1fr))" gap="8px" minWidth="550px">
                        <div app-data-row class="group-head" header>
                            <span></span>
                            <span></span>
                            <span class="group vacation">Vakantie</span>
                        </div>
                        <div app-data-row header>
                            <span>Jaar</span>
                            <span class="text-end">Geregistreerd</span>
                            <span class="text-end">Recht</span>
                            <span class="text-end">Opgenomen</span>
                            <span class="text-end">Gepland</span>
                            <span class="text-end">Resterend</span>
                            <span class="text-end">Ziek</span>
                            <span class="text-end">Balans</span>
                        </div>
                        @for (year of totals.per_year; track year.year) {
                            @let vacationLeft = year.vacation_entitlement_minutes - year.vacation_minutes - year.vacation_planned_minutes;
                            <div app-data-row dense>
                                <span class="ui-strong">{{ year.year }}</span>
                                <span class="text-end ui-mono">{{ year.registered_minutes | minutes:false }}</span>
                                <span class="text-end ui-mono">{{ year.vacation_entitlement_minutes | minutes:false }}</span>
                                <span class="text-end ui-mono">{{ year.vacation_minutes | minutes:false }}</span>
                                <span class="text-end ui-mono">{{ year.vacation_planned_minutes | minutes:false }}</span>
                                <span [class.ui-error]="vacationLeft < 0" class="text-end ui-mono">{{ vacationLeft | minutes:false }}</span>
                                <span [title]="(year.sick_minutes | minutes:false) + ' uur'" class="text-end ui-mono">{{ year.sick_percentage === null ? '—' : (year.sick_percentage | number:'1.2-2') + '%' }}</span>
                                <span [class.ui-error]="year.balance_minutes < 0" class="text-end ui-mono">{{ year.balance_minutes | minutes:false }}</span>
                            </div>
                        }
                    </app-data-list>
                    <p class="note">
                        In uren, over de laatste drie jaar. Opgenomen is vakantie t/m vandaag, gepland is vakantie die na vandaag al geregistreerd is.
                        Het vakantierecht is naar rato van het contractpercentage en de periode in dienst; de vakantiebalans is het resterende verlof van alle jaren in CRM26.
                        Ziek is het percentage van de contracturen t/m vandaag.
                    </p>
                }
            </app-section>

            <app-section [flush]="true" icon="user" layout="stacked" title="Profiel">
                @if (!isOwn()) {
                    <!-- TODO(design): e-mailadres, rollen en contractpercentages van een collega staan niet in profileTotals;
                         alleen de datum in dienst is bekend. -->
                    <app-data-list columns="160px minmax(0,1fr)">
                        <div app-data-row>
                            <span class="ui-muted">In dienst sinds</span>
                            @if (totals?.employment_start) {
                                <span>{{ totals.employment_start | date:'EEEE d MMMM yyyy' }}</span>
                            } @else {
                                <span class="ui-faint">—</span>
                            }
                        </div>
                    </app-data-list>
                    <p class="other-note">E-mailadres, rollen en contractpercentages staan op het eigen profiel van de medewerker.</p>
                } @else {
                <app-data-list columns="160px minmax(0,1fr)">
                    <div app-data-row>
                        <span class="ui-muted">E-mailadres</span>
                        <span class="ui-ellipsis">{{ user?.email }}</span>
                    </div>
                    <div app-data-row>
                        <span class="ui-muted">In dienst sinds</span>
                        @if (user?.employment_start) {
                            <span>{{ user.employment_start | date:'EEEE d MMMM yyyy' }}</span>
                        } @else {
                            <span class="ui-faint">—</span>
                        }
                    </div>
                    <div app-data-row>
                        <span class="ui-muted">Uit dienst</span>
                        @if (user?.employment_end) {
                            <span>{{ user.employment_end | date:'EEEE d MMMM yyyy' }}</span>
                        } @else {
                            <span class="ui-faint">—</span>
                        }
                    </div>
                    <div app-data-row>
                        <span class="ui-muted">Rollen</span>
                        <span class="roles">
                            @for (role of user?.roles; track role.key) {
                                <app-status-badge tone="neutral" variant="chip">{{ role.name }}</app-status-badge>
                            } @empty {
                                <span class="ui-faint">Geen rol</span>
                            }
                        </span>
                    </div>
                </app-data-list>

                <div class="subhead">Contractpercentage</div>
                @if (assignments.length) {
                    <app-data-list columns="minmax(0,1fr) minmax(0,1fr) 90px" gap="12px">
                        <div app-data-row dense header>
                            <span>Van</span>
                            <span>Tot en met</span>
                            <span class="text-end">Percentage</span>
                        </div>
                        @for (assignment of assignments; track assignment.id) {
                            <div app-data-row dense>
                                <span>{{ assignment.begin_date | date:'d MMMM yyyy' }}</span>
                                @if (assignment.end_date) {
                                    <span>{{ assignment.end_date | date:'d MMMM yyyy' }}</span>
                                } @else {
                                    <span class="ui-muted">lopend</span>
                                }
                                <span class="text-end ui-mono">{{ assignment.part_time_rate | percent }}</span>
                            </div>
                        }
                    </app-data-list>
                } @else {
                    <span class="no-periods">Geen periodes ingesteld.</span>
                }
                }
            </app-section>
        </div>

        @if (isOwn()) {
            <div class="column">
                <app-section [flush]="true" icon="envelope" layout="stacked" title="E-mailhandtekening">
                    <!-- TODO(design): README open point 9 - the design replaces support@codalt.com by the own address; the existing
                         behaviour (an extra row with the own address) is kept until that is confirmed -->
                    <mat-checkbox [formControl]="showOwnMail" actions>Toon eigen e-mailadres</mat-checkbox>
                    <div class="signature">
                    <div class="paper">
                    <frame>

                        @let linkStyle = "text-decoration: underline; color: #313840;";
                        @let iconStyle = "border: none; color: #2AE7AC; font-size: 20px; text-align: center; padding-right: 15px;";
                        @let firstName = `${LocalStorage.user?.name.split(' ')[0]}`.toLowerCase().trim();

                        <table cellpadding="0" cellspacing="0" border="0" style="border-collapse: collapse; border: none; font-size:15px;color:rgb(47,56,65);font-family:'Segoe UI', Helvetica, Arial, sans-serif">
                            <tbody>
                                <tr style="font-size:17px;">
                                    <td colspan="2" style="border: none; line-height: 1.8" valign="top" align="left">
                                        <span>Met vriendelijke groet,</span><br>
                                        <b>{{LocalStorage.user?.name}}</b>
                                    </td>
                                </tr>
                                <tr>
                                    @if(base64Image()) {
                                        <td colspan="3" style="border: none;">
                                            &nbsp;&nbsp;&nbsp;<br>
                                            <img width="150" alt="Codalt logo" height="34"
                                                 [src]="base64Image() | safeResourceUrl">
                                            <br>&nbsp;&nbsp;&nbsp;&nbsp;
                                        </td>
                                    }
                                </tr>
                                <tr style="line-height: 2">
                                    <td width="50" style="border: none; {{iconStyle}} font-weight: bold;">
                                        ☏&nbsp;
                                    </td>
                                    <td colspan="2" style="border: none;">
                                        <a href="tel:+31855005060" [attr.style]="linkStyle" target="_blank">
                                            085 - 500&nbsp;5060
                                        </a>
                                    </td>
                                </tr>
                                <tr style="line-height: 2">
                                    <td width="50" style="border: none; {{iconStyle}} font-weight: bold;">
                                        🗪︎&nbsp;
                                    </td>
                                    <td colspan="2" style="border: none;">
                                        <a href="https://wa.me/31855005060" [attr.style]="linkStyle" target="_blank" title="Contact opnemen via WhatsApp">
                                            085 - 500&nbsp;5060
                                        </a>
                                    </td>
                                </tr>
                                <tr style="line-height: 2">
                                    <td valign="top" style="border: none; {{iconStyle}}">
                                        ?&nbsp;
                                    </td>
                                    <td colspan="2" style="border: none;">
                                        <a href="mailto:support@codalt.com" [attr.style]="linkStyle" target="_blank">support@codalt.com</a>
                                    </td>
                                </tr>
                                @if (showOwnMail.value) {
                                    <tr style="line-height: 2">
                                        <td valign="top" style="border: none; {{iconStyle}}">
                                            @&nbsp;
                                        </td>
                                        <td colspan="2" style="border: none;">
                                            <a href="mailto:{{LocalStorage.user?.email}}" [attr.style]="linkStyle" target="_blank">{{LocalStorage.user?.email}}</a>
                                        </td>
                                    </tr>
                                }
                                <tr style="line-height: 2">
                                    <td [attr.style]="'border: none; ' + iconStyle">
                                        ⚑&nbsp;
                                    </td>
                                    <td style="border: none; line-height: 1.4;">
                                        <b>Kopgebouw Dordrecht</b><br>
                                        Leerparkpromenade 40<br>
                                        3312 KW Dordrecht
                                    </td>
                                </tr>
                                <tr style="line-height: 2">
                                    <td style="border: none; {{iconStyle}} font-weight: bold;">
                                        ⤳&nbsp;
                                    </td>
                                    <td colspan="2" style="border: none;">
                                        <a href="https://codalt.com/?utm_source=signature_{{firstName}}" [attr.style]="linkStyle">codalt.com</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </frame>
                    </div>
                    </div>
                </app-section>

                <app-section [flush]="true"
                             icon="calendar"
                             layout="stacked"
                             subtitle="Dit is een persoonlijke URL. Deel deze niet met derden."
                             title="Agenda koppelen">
                    @for (calendar of [{onlyMe: true, title: 'CRM26 kalender URL - alleen mijn afspraken'}, {onlyMe: false, title: 'CRM26 kalender URL'}]; track calendar.onlyMe) {
                        @let copied = calendar.onlyMe ? urlCopiedOwn() : urlCopied();
                        <div class="calendar-url">
                            <span class="calendar-title">{{ calendar.title }}</span>
                            <div class="url-row">
                                <div (click)="copyUrlShare(calendar.onlyMe)" class="url" title="Kopieer URL">
                                    <span class="url-host">{{ environment.apiEndpoint | urlPrefixStripping }}</span><span class="url-path">/ical/{{ LocalStorage.user.calendarUrl }}{{ calendar.onlyMe ? '?onlyMe=true' : '' }}</span>
                                </div>
                                <button (click)="copyUrlShare(calendar.onlyMe)" [class.copied]="copied" class="copy" mat-stroked-button type="button">
                                    <i [class.fa-check]="copied" [class.fa-copy]="!copied" class="fa-regular"></i>
                                    {{ copied ? 'Gekopieerd' : 'Kopieer URL' }}
                                </button>
                            </div>
                        </div>
                    }
                </app-section>
            </div>
        }
    </div>

    @if (isManagement) {
        <app-section [flush]="true" icon="users" layout="stacked" title="Overzicht medewerkers">
            @if (overviewRows(); as rows) {
                <app-data-list [columns]="overviewColumns()" [minWidth]="overviewMinWidth()" gap="10px">
                    <div app-data-row class="group-head" header>
                        <span></span>
                        <span></span>
                        @for (year of overviewYears(); track year) {
                            <span></span>
                            <span class="group year">{{ year }}</span>
                        }
                    </div>
                    <div app-data-row header>
                        <span>Medewerker</span>
                        <span class="text-end">Totaalbalans</span>
                        @for (year of overviewYears(); track year) {
                            <span class="separator"></span>
                            <span class="text-end">Geregistreerd</span>
                            <span class="text-end">Vakantie</span>
                            <span class="text-end">Ziek</span>
                            <span class="text-end">Balans</span>
                        }
                    </div>
                    @for (row of rows; track row.user_id) {
                        @let own = row.user_id === user?.id;
                        @let viewed = row.user_id === viewedUserId();
                        <div (click)="selectUser(row.user_id)"
                             (keydown.enter)="selectUser(row.user_id)"
                             [attr.aria-current]="viewed ? 'true' : null"
                             [class.own]="own"
                             [tone]="viewed ? 'ok' : null"
                             app-data-row
                             class="overview-row"
                             dense
                             tabindex="0">
                            <span class="ui-ellipsis name">{{ row.name }}</span>
                            <span [class.ui-error]="row.balance_minutes < 0" class="text-end ui-mono">{{ row.balance_minutes | minutes:false }}</span>
                            @for (year of row.years; track $index) {
                                <span class="separator"></span>
                                @if (year) {
                                    <span class="text-end ui-mono">{{ year.registered_minutes | minutes:false }}</span>
                                    <span class="text-end ui-mono">{{ year.vacation_minutes | minutes:false }}</span>
                                    <span [title]="(year.sick_minutes | minutes:false) + ' uur'" class="text-end ui-mono">{{ year.sick_percentage === null ? '—' : (year.sick_percentage | number:'1.2-2') + '%' }}</span>
                                    <span [class.ui-error]="year.balance_minutes < 0" class="text-end ui-mono">{{ year.balance_minutes | minutes:false }}</span>
                                } @else {
                                    <span class="text-end none">—</span>
                                    <span class="text-end none">—</span>
                                    <span class="text-end none">—</span>
                                    <span class="text-end none">—</span>
                                }
                            }
                        </div>
                    }
                </app-data-list>
                <p class="note">
                    Medewerkers die voor dit jaar uit dienst zijn gegaan staan er niet in. Uren vanaf de datum in dienst t/m vandaag, over de laatste drie jaar.
                    Balans is geregistreerde uren min contracturen, net als in de rapportage; de totaalbalans telt de hele periode in dienst
                    en de balans per jaar volgt de weeknummers (ISO-jaar), net als de jaarkeuze in de rapportage.
                    Ziek is het percentage van de contracturen t/m vandaag.
                </p>
            } @else {
                <app-empty-state>Laden…</app-empty-state>
            }
        </app-section>
    }
</app-page>
